import axios from 'axios';
import qs from 'qs';

export const stringifyQuery = (params) => (
  qs.stringify(params, { arrayFormat: 'repeat' })
);

export default function createAxios({ host = 'https://api.powerai.com.tw/' }) {
  const instance = axios.create({
    baseURL: host,
  });

  instance.interceptors.response.use((res) => res, (error) => {
    if (!error.response) {
      return Promise.reject(error);
    }

    if (![403, 401].includes(error.response.status)
    || !error.response.data
    || !error.response.data.errors
    || error.response.data.errors[0].field !== 'INVALID_JSON_WEB_TOKEN') {
      return Promise.reject(error);
    }

    return instance(error.response.config);
  });
  // axios.defaults.headers['Content-Type'] = 'application/json';
  delete instance.defaults.headers.common['Content-Type'];
  delete instance.defaults.headers.common['Access-Control-Request-Headers'];
  return instance;
}
